import React, { useRef, useState } from 'react';
import { faAngleDoubleDown, faCheck } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import useWindowDimensions from 'Components/hooks/useWindowDimensions';

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

const formatCode = (code) => {
  return capitalize(code
    .replace('≥', 'at least ')
    .replace('>', 'older than ')
    .replace('<', 'younger than ')
    .replace(/years/, 'years old'))
  ;
};
const showDate = (date) => {
  if (!date) {
    return;
  }
  return new Date() < new Date(date);
};
const formatDate = (date) => {
  if (!date) {
    return;
  }
  const dateLine = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  // const prefix = new Date() > new Date(date) ? 'access since' : 'access from';
  return `planned ${dateLine}`;
};

const handleListScroll = event => event.target.classList.remove('scrollable');

const NationalJurisdiction = (props) => {
  const { jurisdiction } = props;
  const { width: windowWidth } = useWindowDimensions();
  const [activePhase, setActivePhase] = useState(0);
  const colPhaseRef = useRef(null);
  const scrollerFlag = useRef(null);

  const colGroupRef = useRef(null);
  const colGroupItemsRef = useRef(null);

  const [isScrollable, setIsScrollable] = useState(false);

  const priorityGroups = jurisdiction.phases[activePhase].priorityGroups;

  // console.log(priorityGroups);

  return (
    <div className={classnames(component)}>
      <div className='clearfix'>
        <div className='header'>
          <div className='col-phase inline title'>
            Phase
          </div>
          <div className='col-group inline title'>
            Priority groups
          </div>
        </div>
        <div className='table clearfix'>
          <div className='col-phase inline' ref={colPhaseRef}>
            {jurisdiction.phases.map((d, i) => {
              const activeGroup = d.priorityGroups.some(g => g.hasAccessToVaccine);
              return (
                <div
                  className={classnames('tab', { active: i === activePhase })}
                  onClick={() => {
                    setActivePhase(i);
                    if (colPhaseRef.current && i > 2 && (!scrollerFlag.current)) {
                      colPhaseRef.current.scrollTop = (i - 1) * 40;
                      scrollerFlag.current = true;
                    }
                  }}
                  key={i}
                >
                  <div className={classnames('bullet', { active: activeGroup })}>{i + 1}</div>
                </div>
              );
            })}
          </div>

          <div
            ref={colGroupRef}
            className={classnames('col-group inline', (priorityGroups.length > 7 ? 'scrollable' : ''))}
            onScroll={handleListScroll}
          >
            <div className='scroll-icon'>
              <FontAwesomeIcon icon={faAngleDoubleDown} size='lg' />
            </div>
            <ul
              ref={colGroupItemsRef}
            >
              {priorityGroups.map((g, i) => (
                <li
                  key={`${g.code}__${g.description}__${i}`}
                  // title={g.description}
                >
                  <div
                    className={classnames('status', { active: g.hasAccessToVaccine })}
                  >
                    {g.hasAccessToVaccine ? <FontAwesomeIcon icon={faCheck} /> : '⚬'}
                  </div>
                  <div>
                    <span className='status-text'>{formatCode(g.code)}</span>
                    <small
                      className={classnames('status-date', showDate(g.dateGivenAccess) ? '' : 'd-none')}
                    >
                      {g.dateGivenAccess && formatDate(g.dateGivenAccess)}
                    </small>
                    {
                      g.type !== 'age' &&
                    g.code.trim().toLowerCase() !== g.description.trim().toLowerCase() && // Ensure description isn't repetitive
                    (
                      <small
                        className={classnames('status-description', windowWidth > 950 && g.code.length + g.description.length < 80 ? 'inline' : 'block')}
                      >
                        {g.description}
                      </small>
                    )
                    }
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NationalJurisdiction;
